import globals from "@/utils/globals";
import loadScript from "@/utils/load-script";

let recurlyInstance;
let paypal;
let applePay;

export const init = () => {
  return loadScript("https://js.recurly.com/v4/recurly.js")
    .then(() => {
      recurlyInstance = window.recurly;
      recurlyInstance.configure({
        publicKey: globals.recurlyKey,
        required: ["cvv"]
      });
      recurly.cc.elements = recurlyInstance.Elements();
    })
    .catch(e => {
      throw new Error(e);
    });
};

const recurly = {
  paypal: {
    init: (productName, onSuccess, onError) => {
      paypal = recurlyInstance.PayPal({ display: { displayName: productName } });
      paypal.on("token", onSuccess);
      paypal.on("error", onError);
    },
    submit: () => {
      paypal.start();
    }
  },
  applePay: {
    init: (params, onSuccess, onError) => {
      applePay = recurlyInstance.ApplePay(params);
      applePay.on("token", onSuccess);
      applePay.on("error", onError);
    },
    submit: () => {
      applePay.begin();
    }
  },
  cc: {
    submit: (form) => new Promise((resolve, reject) => {
      recurlyInstance.token(recurly.cc.elements, form, (err, token) => {
        if (err) {
          reject(err);
        } else {
          resolve(token);
        }
      });
    }),
    elementStyle: {
      fontFamily: "Montserrat, sans-serif, arial",
      fontSize: "1rem",
      fontColor: "#3E454D",
      background: "#FFFFFF",
      padding: "0",
      placeholder: { color: "#BAC8CE" }
    },
    elements: null
  },
  threeds: {
    challenge: (token, container) => new Promise((resolve, reject) => {
      const risk = recurlyInstance.Risk();
      const threeDSecure = risk.ThreeDSecure({ actionTokenId: token });

      threeDSecure.on("error", reject);
      threeDSecure.on("token", resolve);

      threeDSecure.attach(container);
    })
  }
};

export default recurly;
